module.exports = __webpack_public_path__ + "fonts/Font3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font3.ttf
// module id = 2431
// module chunks = 0